<template>
  <div class="panel panel-primary" itemprop="affiliation" title="Organization" itemscope itemtype="http://schema.org/Organization">
    <div class="panel-heading">
      <h3 class="panel-title"><span class="organization-name fn" itemprop="name">Grotec UK Ltd.</span></h3>
    </div>
    <div class="panel-body">
      <div class="adr" itemprop="address" itemscope itemtype="http://schema.org/PostalAddress">
        <!-- Address -->
        <p><span class="street-address" itemprop="streetAddress">393 Manchester Road</span>,</p>
        <!-- City -->
        <p><span class="locality" itemprop="addressLocality">Rochdale</span>,</p>
        <!-- State -->
        <p><abbr class="region" itemprop="addressRegion" title="Greater Manchester">Gtr Manchester, UK</abbr></p>
        <!-- Zip -->
        <p><abbr class="postal-code" itemprop="postalCode" title="OL11 3PG">OL11 3PG</abbr></p>
        <!-- Country -->
        <!-- Lat/Lon (Metadata) -->
        <div class="hidden">
                <span itemscope itemtype="http://schema.org/Place">
                    <div itemprop="geo">
                        <span itemscope itemtype="http://schema.org/GeoCoordinates">
                            <span itemprop="latitude" content="53.6032501"></span>
                            <span itemprop="longitude" content="-2.1750143"></span>
                        </span>
                    </div>
                </span>
        </div>
      </div>
      <!--/ .adr -->
    </div>
  </div>
</template>
<script>
 export default {
   name: 'contact-vcard',
 }
</script>